var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArqLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18719 10.1088L0 14.296L4.18719 18.4832V10.1088ZM10.1088 4.18719H18.4832L14.296 0L10.1088 4.18719ZM24.4048 10.1088V18.4832L28.592 14.296L24.4048 10.1088ZM18.4832 24.4048H10.1088L14.296 28.592L18.4832 24.4048Z",
    fill: "#F8F9FC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.2959,
    r: 7,
    fill: "#F8F9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArqLogo);
export default __webpack_public_path__ + "static/media/ArqLogo.fe28f367c2933441ed837467a9fee6af.svg";
export { ForwardRef as ReactComponent };